import React from "react"
import { Link } from "gatsby";
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Button } from '@atoms';

import ResultsDocument from "./ResultsDocument";

import { ButtonWrapper } from "../styles/ButtonSection.styled";

const ButtonSection = ({ isDetail, handleClick, formSubmitted, annualApprovalsSavings, prodHoursSaved, annualProductivitySavings, annualItSavings, total, ticketsPerEmp, employees }) => {

  switch (isDetail) {
    case true :
      return (
        <ButtonWrapper>
          {formSubmitted ? 
            <PDFDownloadLink 
              document={
                <ResultsDocument                   
                  annualApprovalsSavings={annualApprovalsSavings}
                  annualProductivitySavings={annualProductivitySavings}
                  annualItSavings={annualItSavings}
                  total={total}
                  prodHoursSaved={prodHoursSaved}
                  ticketsPerEmp={ticketsPerEmp}
                  employees={employees}
                />
              }
              fileName="workgrid-roi-results.pdf"
            >
              {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download Full Report')}
            </PDFDownloadLink> 
            : 
            <Link to="/roi-calculator/">ROI Calculator</Link>
          }
        </ButtonWrapper>
      )
    default :
      return (
        <ButtonWrapper 
          onClick={(e) => handleClick(e)}
        >
          <Button ctaVariant='primary'>See Detailed Report</Button>
        </ButtonWrapper>
      )
  }
}

export default ButtonSection